import React from "react";
import { LessonView as CoreLessonView } from "@jelly/lesson";

import defaultStyle from "./LessonView.module.scss";

export const LessonView: React.FC<React.ComponentProps<typeof CoreLessonView>> = (props) => {
  return <CoreLessonView {...props} style={defaultStyle} />;
};
